import { chain, find } from 'lodash'
import { useContext, useEffect, useState } from 'react'

import { AppContext } from 'providers/context/App'
import { getAvailableServices } from 'services/Cart'
import { services } from 'utils/constants/services'
import useNavigate from 'utils/navigation/useCustomNavigate'

const useServices = () => {
  const { appMasterData } = useContext(AppContext)
  const { isInfluencerFlow } = useNavigate()

  const [facialName, setFacialName] = useState('')

  useEffect(() => {
    const getAvailableAllServices = async () => {
      const allServices = await getAvailableServices(appMasterData.cart.cartId)
      const getFacialObj = chain(allServices.cart.availableCategories)
        .filter({ name: 'Facials' })
        .take()
        .first()
        .thru((x) =>
          find(x.availableItems, {
            id: services?.[0]?.id,
          })
        )
        .value()
      setFacialName(getFacialObj?.name)
    }
    isInfluencerFlow && appMasterData.cart.cartId && getAvailableAllServices()
  }, [isInfluencerFlow, appMasterData.cart.cartId])

  return {
    facialName,
  }
}

export default useServices
